/*
 * Shell de la aplicacion. Porta app.component.ts y app.component.html del original.
 *
 * El spike tenia aqui una plantilla en linea que montaba las tres pantallas portadas a la
 * vez (<app-administracion /><app-bines-abc /><app-binmanager />). Servia para verificar
 * el pintado sin ruteo, que es para lo que se hizo, pero no es la aplicacion: no habia
 * navbar, ni router-outlet activo, ni guard. app.html, con la pagina de bienvenida de
 * Angular, quedaba huerfano porque esta plantilla en linea lo reemplazaba.
 *
 * Se conserva la logica original: el navbar solo se pinta con usuario autenticado, y
 * SessionTimeoutService se inyecta aqui para que arranque el temporizador de 15 minutos.
 */
import { Component, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';

import { AuthenticationService } from './_services/authentification.service';
import { SessionTimeoutService } from './_services/session-timeout.service';
import { User } from './_models/oauth.models';
import { NavbarComponent } from './semantic/navbar/navbar.component';
import { LoadingComponent } from './semantic/loading/loading.component';

@Component({
	selector: 'app-root',
	imports: [CommonModule, RouterOutlet, NavbarComponent, LoadingComponent],
	template: `
		<div *ngIf="currentUser">
			<app-navbar></app-navbar>
		</div>
		<app-loading></app-loading>
		<router-outlet></router-outlet>
	`,
})
export class App implements OnDestroy {
	currentUser: User | null = null;

	private readonly authenticationService = inject(AuthenticationService);
	// Se inyecta aunque no se use directamente: su constructor arma el temporizador de
	// inactividad. Era el mismo arreglo en el AppComponent original.
	private readonly sessionTimeoutService = inject(SessionTimeoutService);
	private readonly sub: Subscription;

	constructor() {
		// El original usaba la forma de 3 callbacks de subscribe(), retirada en RxJS 7.
		// Equivale a este objeto observador.
		this.sub = this.authenticationService.currentUser.subscribe({
			next: (x) => (this.currentUser = x),
			error: (err) => console.error('AppComponent currentUser:', err),
		});
	}

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}
}
